'use client'

import Link from 'next/link'

const AHeroButtonContent = ({ text }: { text: string }) => {
	return (
		<>
			<span className='whitespace-nowrap mx-0! px-5! py-1! text-center!'>{text}</span>
		</>
	)
}

/**
 * Home hero CTA row: two fixed {@link Link} targets (`/volne-terminy`, `/rocne-programy`) in a
 * horizontal flex layout, each using `btn_basic` styling and the shared double-arrow icon pattern.
 *
 * @remarks The module default export is still re-exported as `AHomeHeroOrderButton` from
 * `./index.ts` for backwards compatibility; the implementation identifier is {@link AHomeHeroCTAButtons}.
 *
 * @example
 * ```tsx
 * import AHomeHeroCTAButtons from './a-home-hero-order-button'
 *
 * <AHomeHeroCTAButtons />
 * ```
 *
 * @returns Flex wrapper containing both hero CTAs.
 */
const AHomeHeroCTAButtons = () => {
	return (
		<div className='flex flex-row gap-4 md:flex-wrap'>
			<Link
				href='/volne-terminy'
				title='Objednajte sa online'
				className='btn_basic cyclamen w-full md:w-fit'
				aria-label='Objednajte sa online'
			>
				<AHeroButtonContent text='Objednajte sa' />
			</Link>

			<Link
				href='/rocne-programy'
				title='Ročné programy'
				className='btn_basic blue w-full md:w-fit'
				aria-label='Ročné programy'
			>
				<AHeroButtonContent text='Ročné programy' />
			</Link>
		</div>
	)
}

export default AHomeHeroCTAButtons
